import HeroSection from "../../components/pages/home/hero-section/HeroSection";
import SelectedServicesSection from "../../components/pages/home/selected-services-section/SelectedServicesSection";
import ServicesSection from "../../components/pages/home/services-section/ServicesSection";
import OffersWeek from "../../components/pages/home/offers-of-the-week/OffersWeek";
import ProductSection from "../../components/pages/home/product-section/ProductSection";
// import FactsCounterSection from "../../components/facts-counter-section/FactsCounterSection";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <SelectedServicesSection />
      <OffersWeek />
      <ProductSection />
      {/* <FactsCounterSection /> */}
      <ServicesSection />
    </div>
  );
};

export default Home;
